import VerificationCodeInput from '@helpers/helpComponents/VerificationCode';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Animated } from 'react-animated-css';
import { Button, Card, Col, Container, Form, Image, Row } from 'react-bootstrap'
import { NotificationManager } from 'react-notifications';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import LecturaEvaluacion from './LecturaEvaluacion';
import EventoAcceso from './AccesoEvento';
import UserContext from '@context/User/UserContext';
import dashboardRoutesPaths from '@helpers/dashboardRoutesPaths/dashboardRoutesPaths';

const particlesOptions = {
    fpsLimit: 60,
    particles: {
        number: {
            value: 100,
            density: {
                enable: true,
            },
        },
        color: {
            value: ["#ffcc00", "#ffffff", "#ff9900"],
        },
        opacity: {
            value: { min: 0.1, max: 0.6 },
        },
        size: {
            value: { min: 1, max: 3 },
        },
        move: {
            enable: true,
            speed: 4,
            random: false,
        },
    },
    interactivity: {
        detectsOn: "window",
        events: {
            onClick: {
                enable: true,
                mode: "push",
            },
            resize: true,
        },
    },
    background: {
        image: "url('https://globalclickmexico.com/img/loginNuevo.webp')",
        position: "50% 50%",
        size: "cover",
        repeat: "no-repeat",
    },
};

const validarCodigoAcceso = (codigo) =>{
    console.log('Codigo validado, ', codigo);
    NotificationManager.success("Codigo validado")
}

const CompetenciasLecturaVeloz = ({history}) => {

    const {contextValue, setContexValue} = useContext(UserContext);

    const {usuarioLogeado = {}} = contextValue;

    const [showEvaluacion, setShowEvaluacion] = useState(false);

    const [codigoCompetencia, setCodigoCompetencia] = useState('CLV5');

    //todo Desarrollar las 3 fases para la prueba:
    //*Primer evento de clasificatoria con un temporizador normal
    //*Segundo evento de clasificatoria con un contra reloj
    //*Evento de cierre del curso.
    
    // const particlesInit = useCallback(async (engine) => {
    //         await loadFull(engine);
    //     }, []);

    //Se reciben los datos para manejarlos en la vista pública
    const param = new URLSearchParams(window.location.search);


    useEffect(() => {
        const datosURL = param.get("competencia");

        console.log(datosURL);

        if(datosURL){
            setCodigoCompetencia(datosURL);
        }

        if(Object.keys(usuarioLogeado).length === 0){
                history.replace(dashboardRoutesPaths.default);
        }
    }, [])
    
    return (

        <>

            {showEvaluacion ? (
                <LecturaEvaluacion codigoCompetencia={codigoCompetencia} usuarioLogeado={usuarioLogeado} />
            ): (
                <EventoAcceso codigoCompetencia={codigoCompetencia} usuarioLogeado={usuarioLogeado} setShowEvaluacion={setShowEvaluacion} />
            )}


        </>
        
    )
}

export default CompetenciasLecturaVeloz